import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';
import ApiURL from '../Api/Api';
import Navbar from './Navbar';
import { SidebarContext } from './SidebarContext';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';

const TransactionFullyHistoryReport = () => {
  const [transactions, setTransactions] = useState([
    {
      history_id: 1,
      transaction_no: 57,
      user_id: 1,
      transaction_date: '2025-07-22',
      amount_type: 'debit',
      credit_amt: 0.00,
      debit_amt: 8000.00,
      net_balance: 28900.00,
      particuler_to: 'Dinesh',
      site: 'Okhla',
      main_head: 'Office',
      sub_head: 'Running expense',
      remarks: 'balance Salary',
      form_status: 'RECEIVED',
      created_by: 'mn.pandey',
      created_at: '2025-07-22 13:48:24',
      updated_by: '',
      updated_date: '',
      version_type: 'original',
      edit_timestamp: '2025-07-24 19:32:48',
    },
    {
      history_id: 2,
      transaction_no: 57,
      user_id: 1,
      transaction_date: '2025-07-22',
      amount_type: 'debit',
      credit_amt: 0.00,
      debit_amt: 8000.00,
      net_balance: 28910.00,
      particuler_to: 'Dinesh',
      site: 'Okhla',
      main_head: 'Office',
      sub_head: 'Running expense',
      remarks: 'balance Salary',
      form_status: 'RECEIVED',
      created_by: 'mn.pandey',
      created_at: '2025-07-22 13:48:24',
      updated_by: 'mn.pandey',
      updated_date: '2025-07-24 19:32:48',
      version_type: 'updated',
      edit_timestamp: '2025-07-24 19:32:48',
    },
    // Include other data entries similarly...
  ]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [searchParticuler, setSearchParticuler] = useState('');
  const [searchDate, setSearchDate] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Set to false since using static data
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { isSidebarOpen, screenWidth } = useContext(SidebarContext);

  useEffect(() => {
    // In a real app, fetch data from API here
    setFilteredTransactions(transactions);
  }, [transactions]);

  useEffect(() => {
    const filtered = transactions.filter(
      (transaction) =>
        transaction.particuler_to.toLowerCase().includes(searchParticuler.toLowerCase()) &&
        transaction.transaction_date.includes(searchDate)
    );
    setFilteredTransactions(filtered);
  }, [searchParticuler, searchDate, transactions]);

  const exportToCSV = () => {
    let csvContent = "data:text/csv;charset=utf-8,";
    const headers = [
      'History ID',
      'Transaction No',
      'Transaction Date',
      'Amount Type',
      'Debit Amount',
      'Net Balance',
      'Particuler To',
      'Site',
      'Main Head',
      'Sub Head',
      'Remarks',
      'Form Status',
      'Created By',
      'Created At',
      'Updated By',
      'Updated Date',
      'Version Type',
      'Edit Timestamp',
    ];
    csvContent += headers.join(',') + '\r\n';

    filteredTransactions.forEach((transaction) => {
      const row = [
        transaction.history_id,
        transaction.transaction_no,
        transaction.transaction_date,
        transaction.amount_type,
        transaction.debit_amt,
        transaction.net_balance,
        transaction.particuler_to,
        transaction.site,
        transaction.main_head,
        transaction.sub_head,
        transaction.remarks,
        transaction.form_status,
        transaction.created_by,
        transaction.created_at,
        transaction.updated_by || '',
        transaction.updated_date || '',
        transaction.version_type,
        transaction.edit_timestamp,
      ];
      csvContent += row.join(',') + '\r\n';
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'TransactionHistoryReport.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-blue-100 pt-16 font-sans">
      <Navbar />
      <div className="flex flex-1 relative">
        <Sidebar />
        <motion.main
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className={`flex-1 min-h-screen p-2 sm:p-3 overflow-y-auto ${
            isSidebarOpen ? 'sm:ml-64' : 'ml-0'
          } transition-margin duration-200`}
        >
          <div className="p-4 sm:p-6">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h1 className="text-2xl sm:text-4xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-blue-500 mx-auto py-4">
                TRANSACTION HISTORY REPORT
              </h1>
              <div className="w-24"></div>
            </div>

            <div className="mt-6">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="flex flex-col sm:flex-row gap-2 mb-6 max-w-4xl mx-auto"
              >
                <input
                  type="text"
                  value={searchParticuler}
                  onChange={(e) => setSearchParticuler(e.target.value)}
                  placeholder="Search by Particuler To..."
                  className="flex-grow p-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-[10px] sm:text-sm bg-white/90"
                />
                <input
                  type="text"
                  value={searchDate}
                  onChange={(e) => setSearchDate(e.target.value)}
                  placeholder="Search by Date (YYYY-MM-DD)"
                  className="flex-grow p-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-[10px] sm:text-sm bg-white/90"
                />
                <button
                  type="button"
                  onClick={exportToCSV}
                  className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 flex items-center justify-center text-[10px] sm:text-sm transition-colors duration-200"
                >
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Export to CSV
                </button>
              </form>

              {isLoading ? (
                <div className="text-center py-8 text-blue-600 text-[10px] sm:text-sm">
                  Loading transactions...
                </div>
              ) : error ? (
                <div className="text-center py-8 text-red-600 text-[10px] sm:text-sm">
                  Error: {error}
                </div>
              ) : filteredTransactions.length === 0 ? (
                <div className="text-center py-8 text-blue-600 text-[10px] sm:text-sm">
                  No transactions found
                </div>
              ) : (
                <div className="relative overflow-x-auto w-full">
                  <table className="w-full text-[10px] sm:text-xs text-left text-gray-700 shadow-md rounded-lg overflow-hidden">
                    <thead className="text-[10px] sm:text-xs uppercase bg-blue-200 text-black sticky top-0 z-10">
                      <tr>
                        <th className="px-2 py-1.5 sticky left-0 bg-blue-200 z-20">History ID</th>
                        <th className="px-2 py-1.5">Transaction No</th>
                        <th className="px-2 py-1.5">Date</th>
                        <th className="px-2 py-1.5">Amount Type</th>
                        <th className="px-2 py-1.5">Debit Amount</th>
                        <th className="px-2 py-1.5">Net Balance</th>
                        <th className="px-2 py-1.5">Particuler To</th>
                        <th className="px-2 py-1.5">Site</th>
                        <th className="px-2 py-1.5">Main Head</th>
                        <th className="px-2 py-1.5">Sub Head</th>
                        <th className="px-2 py-1.5">Remarks</th>
                        <th className="px-2 py-1.5">Status</th>
                        <th className="px-2 py-1.5">Created By</th>
                        <th className="px-2 py-1.5">Created At</th>
                        <th className="px-2 py-1.5">Updated By</th>
                        <th className="px-2 py-1.5">Updated Date</th>
                        <th className="px-2 py-1.5">Version Type</th>
                        <th className="px-2 py-1.5">Edit Timestamp</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTransactions.map((transaction, index) => (
                        <tr
                          key={index}
                          className="bg-white border-b hover:bg-blue-50 transition-colors duration-200"
                        >
                          <td className="px-2 py-1.5 sticky left-0 bg-white z-10 font-medium text-blue-600">
                            {transaction.history_id}
                          </td>
                          <td className="px-2 py-1.5">{transaction.transaction_no}</td>
                          <td className="px-2 py-1.5">{transaction.transaction_date}</td>
                          <td className="px-2 py-1.5">{transaction.amount_type}</td>
                          <td className="px-2 py-1.5">{transaction.debit_amt.toFixed(2)}</td>
                          <td className="px-2 py-1.5">{transaction.net_balance.toFixed(2)}</td>
                          <td className="px-2 py-1.5">{transaction.particuler_to}</td>
                          <td className="px-2 py-1.5">{transaction.site}</td>
                          <td className="px-2 py-1.5">{transaction.main_head}</td>
                          <td className="px-2 py-1.5">{transaction.sub_head}</td>
                          <td className="px-2 py-1.5">{transaction.remarks}</td>
                          <td className="px-2 py-1.5">{transaction.form_status}</td>
                          <td className="px-2 py-1.5">{transaction.created_by}</td>
                          <td className="px-2 py-1.5">{transaction.created_at}</td>
                          <td className="px-2 py-1.5">{transaction.updated_by || '-'}</td>
                          <td className="px-2 py-1.5">{transaction.updated_date || '-'}</td>
                          <td className="px-2 py-1.5">{transaction.version_type}</td>
                          <td className="px-2 py-1.5">{transaction.edit_timestamp}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="sm:hidden absolute top-0 right-0 h-full w-3 bg-gradient-to-l from-gray-200/50 to-transparent pointer-events-none"></div>
                </div>
              )}

              {error && (
                <div className="mt-4 px-4 py-2 bg-red-100 text-red-600 rounded text-[10px] sm:text-sm max-w-4xl mx-auto">
                  {error}
                </div>
              )}
            </div>
          </div>
        </motion.main>
        {isSidebarOpen && screenWidth < 640 && (
          <div
            className="fixed inset-0 bg-black/50 z-30"
            onClick={() => document.querySelector('button[aria-label="Close Sidebar"]').click()}
            aria-hidden="true"
          />
        )}
      </div>

      <style jsx>{`
        .overflow-x-auto {
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        @media (max-width: 480px) {
          .overflow-x-auto {
            max-width: 100vw;
          }
          table {
            min-width: 1200px; /* Adjusted for more columns */
            width: auto;
          }
        }
        main {
          min-width: 0;
          flex: 1 1 auto;
        }
      `}</style>
    </div>
  );
};

export default TransactionFullyHistoryReport;